export default __webpack_public_path__ + "static/media/triangles-no-6.3cd4ec8e.ogg";